(function()
{
    //Import classes
    var BaseState = include('springroll.easeljs.BaseState'),
        GamePanel = include('WGBH.GamePanel'),
        Tween = include('createjs.Tween');

    /**
     * The logic for the Game state
     * @class WGBH.GameState
     * @extends springroll.easeljs.BaseState
     */
    var GameState = function(options)
    {
        BaseState.call(this, new GamePanel(), options);
    };

    //Extend the base state
    var p = extend(GameState, BaseState);

    helpStep = 1;

    // Shared Variables
    var numPossiblePaths = 12;
    var pathNum;     
    var row1;
    var row2;
    var row3;
    var row4;
    var row5;

    // set up obstacle info
    var numObstacles = 0;
    var goalNumObstacles;
    var numObstacleOrders = 9;
    var obstacleOrder0 = [1,2,3,4,5,6,7,8,9,"A","B","C"];
    var obstacleOrder1 = [2,4,6,8,"A","C",1,3,5,7,9,"B"];
    var obstacleOrder2 = [3,5,7,9,"B",2,4,6,8,"A","C",1];
    var obstacleOrder3 = [4,7,"A",1,5,8,"B",2,6,9,"C",3];
    var obstacleOrder4 = [5,8,"B",2,6,9,"C",3,7,1,4,"A"];
    var obstacleOrder5 = [6,"A",2,7,"B",3,8,"C",1,5,9,4];
    var obstacleOrder6 = [7,"B",2,6,"A","C",1,5,9,4,8,3];
    var obstacleOrder7 = [8,"C",4,9,5,"A",1,6,2,"B",7,3];
    var obstacleOrder8 = [9,5,"C","B",1,6,2,7,3,8,"A",4];
    var obstacleOrder;

    var obstacle1_text = "ball";
    var obstacle2_text = "toy Crazy Bus";
    var obstacle3_text = "doll";
    var obstacle4_text = "rubber duck";
    var obstacle5_text = "jack-in-the-box";
    var obstacle6_text = "Mary Moo Cow doll";
    var obstacle7_text = "radio";
    var obstacle8_text = "rattle";
    var obstacle9_text = "toy robot";
    var obstacleA_text = "toy phone";
    var obstacleB_text = "toy train";
    var obstacleC_text = "xylophone";  

    var obstacle1_sound = "ball";
    var obstacle2_sound = "bus";
    var obstacle3_sound = "doll";
    var obstacle4_sound = "duck";
    var obstacle5_sound = "jackinthebox";
    var obstacle6_sound = "mmcow";
    var obstacle7_sound = "radio";
    var obstacle8_sound = "rattle";
    var obstacle9_sound = "robot";
    var obstacleA_sound = "phone";
    var obstacleB_sound = "train";
    var obstacleC_sound = "xylophone"; 

    var obstacle1_vo = "oops_ball";
    var obstacle2_vo = "oops_bus";
    var obstacle3_vo = "oops_doll";
    var obstacle4_vo = "oops_duck";
    var obstacle5_vo = "oops_jack";
    var obstacle6_vo = "oops_cow";
    var obstacle7_vo = "oops_radio";
    var obstacle8_vo = "oops_rattle";
    var obstacle9_vo = "oops_robot";
    var obstacleA_vo = "oops_phone";
    var obstacleB_vo = "oops_train";
    var obstacleC_vo = "oops_xylo";

    var obstacle1_vo_nad = "oops_ball_NAD";
    var obstacle2_vo_nad = "oops_bus_NAD";
    var obstacle3_vo_nad = "oops_doll_NAD";
    var obstacle4_vo_nad = "oops_duck_NAD";
    var obstacle5_vo_nad = "oops_jack_NAD";
    var obstacle6_vo_nad = "oops_cow_NAD";
    var obstacle7_vo_nad = "oops_radio_NAD";
    var obstacle8_vo_nad = "oops_rattle_NAD";
    var obstacle9_vo_nad = "oops_robot_NAD";
    var obstacleA_vo_nad = "oops_phone_NAD";
    var obstacleB_vo_nad = "oops_train_NAD";
    var obstacleC_vo_nad = "oops_xylo_NAD";    
    var disabled;  

    /**
     * After assets are loaded and state is fully entered
     * @method  enterDone
     */
    p.enterDone = function()
    {   
        disabled = true;

        if (version){
            console.log("Version: " + version);
        }

        // Bindings 
        this.onSuccess = this.onSuccess.bind(this);
        this.onFail = this.onFail.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onReset = this.onReset.bind(this);
        this.newGame = this.newGame.bind(this);
        this.placeObstacles = this.placeObstacles.bind(this);
        this.checkObstacle = this.checkObstacle.bind(this);
        this.onTryAgain = this.onTryAgain.bind(this);
        this.getGridPos = this.getGridPos.bind(this);
        this.onHelpClick = this.onHelpClick.bind(this);
        this.onPlayClick = this.onPlayClick.bind(this);
        this.onNextClick = this.onNextClick.bind(this);
        this.onHelpReset = this.onHelpReset.bind(this);
        this.onADClick = this.onADClick.bind(this);
        this.onHomeClick = this.onHomeClick.bind(this);

        this.onArrowUpHover = this.onArrowUpHover.bind(this);
        this.onArrowDownHover = this.onArrowDownHover.bind(this);
        this.onArrowLeftHover = this.onArrowLeftHover.bind(this);
        this.onArrowRightHover = this.onArrowRightHover.bind(this);

        this.onArrowUpClick = this.onArrowUpClick.bind(this);
        this.onArrowDownClick = this.onArrowDownClick.bind(this);
        this.onArrowLeftClick = this.onArrowLeftClick.bind(this);
        this.onArrowRightClick = this.onArrowRightClick.bind(this);

        // UI Container 
        this.UIContainer = this.panel.UIContainer;

        // Buttons
        this.panel.tryAgain.addEventListener('click', this.onTryAgain);
        this.panel.playAgain.addEventListener('click', this.onReset);
        this.panel.helpButton.addEventListener('click', this.onHelpClick);
        this.panel.help_playBtn.addEventListener('click', this.onPlayClick);
        this.panel.help_nextBtn.addEventListener('click', this.onNextClick);
        this.panel.help_helpButton.addEventListener('click', this.onHelpReset);
        this.panel.help_audioButton.addEventListener('click', this.onADClick);
        this.panel.audioButton.addEventListener('click', this.onADClick);
        this.panel.help_audioButton_active.addEventListener('click', this.onADClick);
        this.panel.audioButton_active.addEventListener('click', this.onADClick);
        this.panel.homeBtn.addEventListener('click', this.onHomeClick);
        this.panel.help_homeBtn.addEventListener('click', this.onHomeClick);

        // Mouse Movement and Hovers
        this.panel.arrowUpBG.addEventListener('mouseover', this.onArrowUpHover);
        this.panel.arrowUpBG.addEventListener('mouseout', this.onArrowUpHover);
        this.panel.arrowUpBG.addEventListener('click', this.onArrowUpClick);

        this.panel.arrowDownBG.addEventListener('mouseover', this.onArrowDownHover);
        this.panel.arrowDownBG.addEventListener('mouseout', this.onArrowDownHover);
        this.panel.arrowDownBG.addEventListener('click', this.onArrowDownClick);

        this.panel.arrowLeftBG.addEventListener('mouseover', this.onArrowLeftHover);
        this.panel.arrowLeftBG.addEventListener('mouseout', this.onArrowLeftHover);
        this.panel.arrowLeftBG.addEventListener('click', this.onArrowLeftClick);

        this.panel.arrowRightBG.addEventListener('mouseover', this.onArrowRightHover);
        this.panel.arrowRightBG.addEventListener('mouseout', this.onArrowRightHover);
        this.panel.arrowRightBG.addEventListener('click', this.onArrowRightClick);

        // Keyboard Controls
        window.addEventListener('keydown', this.onKeyPress);
        this.onReset();

        if (version == 'ad'){
            app.voPlayer.play(['play_audio_version', 'home_1', 'home_2']);
        } else if (version == 'touch') {
            app.voPlayer.play(['home_1', 'home2_alt_NAD']);
        } else {
            app.voPlayer.play(['play_audio_version', 'home_1', 'home2_alt_NAD']);
        }
    };

    /**
     * start a new Game
     * 
     * 
     */
    p.newGame = function () 
    {
        // Reset Obstacle Object
        for( i = 0; i <= 4; i++){            
            for( n = 0; n <= 4; n++){
                this.panel.obstacles[i + 1][n + 1].hasObstacle = false;
                this.panel.obstacles[i + 1][n + 1].obstacle = '';
            }
        }

        numObstacles = 0;    
        numPossiblePaths = 12;
        pathNum = Math.floor(Math.random() * 12) + 1;     // returns a number between 1 and 12;

        /* 
            based on pathnum, set up rows
             E     => empty
             -     => designated path
             *     => designated empty
             [1-9] => obstacle 
        */

        if (pathNum == 1) {
            row1 = "--EE*";
            row2 = "E-EE*";
            row3 = "--EEE";
            row4 = "-EEEE";
            row5 = "-----";

        } else if (pathNum == 2) {
            row1 = "---EE";
            row2 = "EE-EE";
            row3 = "---EE";
            row4 = "-EEEE";
            row5 = "-----";

        } else if (pathNum == 3) {
            row1 = "---EE";
            row2 = "*E-E*";
            row3 = "E--EE";
            row4 = "E-EEE";
            row5 = "E----";

        } else if (pathNum == 4) {
            row1 = "----E";
            row2 = "EEE-E";
            row3 = "E---E";
            row4 = "E-EEE";
            row5 = "E----";

        } else if (pathNum == 5) {
            row1 = "----E";
            row2 = "EEE-E";
            row3 = "*E--E";
            row4 = "EE-EE";
            row5 = "*E---";

        } else if (pathNum == 6) {
            row1 = "-----";
            row2 = "EEEE-";
            row3 = "EE---";
            row4 = "EE-EE";
            row5 = "EE---";

        } else if (pathNum == 7) {
            row1 = "-E---";
            row2 = "---E-";
            row3 = "EEEE-";
            row4 = "EEEE-";
            row5 = "**EE-";

        } else if (pathNum == 8) {
            row1 = "-E---";
            row2 = "-E-E-";
            row3 = "---E-";
            row4 = "EEEE-";
            row5 = "EEEE-";

        } else if (pathNum == 9) {
            row1 = "-*EEE";
            row2 = "-E---";
            row3 = "---E-";
            row4 = "EEEE-";
            row5 = "E*EE-";

        } else if (pathNum == 10) {
            row1 = "-EEEE";
            row2 = "-E---";
            row3 = "-E-E-";
            row4 = "---E-";
            row5 = "EEEE-";

        } else if (pathNum == 11) {
            row1 = "-E*E*";
            row2 = "-EEEE";
            row3 = "-E---";
            row4 = "---E-";
            row5 = "EEEE-";

        } else if (pathNum == 12) {
            row1 = "-EEEE";
            row2 = "-EEEE";
            row3 = "-E---";
            row4 = "-E-E-";
            row5 = "---E-";
        }        

        // set up obstacleOrder by choosing a random obstacleOrder
        obstacleOrder = eval("obstacleOrder" + Math.floor(Math.random() * 9));// jshint ignore:line  
        // console.log("New Game Debug");
        // console.log('---------------------');
        // console.log("Path Number: " + pathNum);
        // console.log('Row 1: ' + row1);
        // console.log('Row 2: ' + row2);
        // console.log('Row 3: ' + row3);
        // console.log('Row 4: ' + row4);
        // console.log('Row 5: ' + row5);
        // console.log("Obstacle Order: " + obstacleOrder);            
        
        disabled = false;
    };

     /**
     * Handler to place obstacles 
     * @method  placeObstacles
     * @private
     */
    p.placeObstacles = function()
    {

        if (numObstacles <= 3) {
            goalNumObstacles = 4;
        } else if (numObstacles <= 4) {
            goalNumObstacles = 5;
        } else if (numObstacles <= 5) {
            goalNumObstacles = 6;
        } else if (numObstacles <= 6) {
            goalNumObstacles = 7;
        } else if (numObstacles <= 7) {
            goalNumObstacles = 8;
        } else if (numObstacles <= 8) {
            goalNumObstacles = 9;
        } else if (numObstacles <= 9) {
            goalNumObstacles = 10;
        } else if (numObstacles <= 10) {
            goalNumObstacles = 11;
        } else {
            goalNumObstacles = 12;
        } 

        while (goalNumObstacles > numObstacles){

            randRow = parseInt(Math.floor(Math.random() * 5) + 1); // Random row number between 1 - 5
            randCol = parseInt(Math.floor(Math.random() * 5) + 1); // Random col number between 1 - 5

            this.row = eval("row"+randRow);// jshint ignore:line 
            grid_val = this.row.substr((randCol-1), 1);

            if (grid_val == "E" && this.panel.obstacles[randRow][randCol].hasObstacle !== true){ // jshint ignore:line
                this.panel.obstacles[randRow][randCol].hasObstacle = true;
                this.panel.obstacles[randRow][randCol].obstacle = "obstacle" + obstacleOrder[numObstacles];
                
                numObstacles++;
            }
        }
    };

    /**
     * Handler to check if obstacles was hit
     * @method  checkObstacle
     * @private
     */
    p.checkObstacle = function(row, col)
    {
        this.row_num = row;
        this.col_num = col;

        this.row = eval("row" + this.row_num); // jshint ignore:line
        // console.log("Check Obstacle Debug");
        // console.log("Row to Evaluate:" + this.row);
        // console.log(this.panel.obstacles[this.row_num][this.col_num]);
        
        if (this.panel.obstacles[this.row_num][this.col_num].hasObstacle !== false){
            return false;
        } else {
            return true;
        }

    };

    /**
     * Handler When to Show Touch Arrows
     * @method onTouchArrows
     * @private
     */
    p.onTouchArrows = function()
    {
        var x = this.panel.dw.x,
            y = this.panel.dw.y;

        if (x === 175) {
            this.panel.arrowLeftBG.alpha = 0;
            this.panel.arrowLeft.alpha = 0;
        } else {
            this.panel.arrowLeftBG.alpha = 1;
            this.panel.arrowLeft.alpha = 1;
        }

        if (x == 375) {
            this.panel.arrowRightBG.alpha = 0;
            this.panel.arrowRight.alpha = 0;
        } else {
            this.panel.arrowRightBG.alpha = 1;
            this.panel.arrowRight.alpha = 1;
        }

        if (y === 68.5) {
            this.panel.arrowUpBG.alpha = 0;
            this.panel.arrowUp.alpha = 0;
        } else {
            this.panel.arrowUpBG.alpha = 1;
            this.panel.arrowUp.alpha = 1;
        }

        if (y === 268.5) {
            this.panel.arrowDown.alpha = 0;
            this.panel.arrowDownBG.alpha = 0;
        } else {
            this.panel.arrowDown.alpha = 1;
            this.panel.arrowDownBG.alpha = 1;
        }
       
    };

    /**
     * Handler when Up Arrow Hover
     * @method  onArrowUpHover
     * @private
     */
    p.onArrowUpHover = function(event)
    {
        type = event.type;
        y = this.panel.dw.y;

        if (type === 'mouseover' && y > 68.5){
            this.panel.arrowUpBG.alpha = 1;
            this.panel.arrowUp.alpha = 1;
            app.sound.play('ButtonRollover');

        } else if (type === 'mouseout'){
            this.panel.arrowUpBG.alpha = 0;
            this.panel.arrowUp.alpha = 0;
        }
    };

    /**
     * Handler when the clicking on a grid item
     * @method  onArrowUpClick
     * @private
     */

     p.onArrowUpClick = function(event)
    {   
        if (disabled !== true){

            var x = this.panel.dw.x,
                y = this.panel.dw.y,
                dw_orig_x = 175,
                dw_orig_y = 68.5,
                target = event.target,
                coords, 
                valid = false;

            if (y > 68.5){
                this.panel.dw.y = y - 50;

                if (version != 'touch') {
                   this.panel.arrowUpBG.alpha = 0;
                    this.panel.arrowUp.alpha = 0; 
                } else {
                    this.onTouchArrows();
                }
                
                app.sound.play('ButtonClick');
                coords = this.getGridPos();
                loc_vo = "loc_" + coords.x + "_" + coords.y;
                valid = true;
            }

           if (valid) {
                
                if (this.checkObstacle(coords.x, coords.y) ){

                    if (version == "ad"){
                        app.voPlayer.stop();
                        app.voPlayer.play(loc_vo);
                    }                    

                    if (coords.x == 5 && coords.y == 5){              
                        this.panel.dw.x = dw_orig_x;
                        this.panel.dw.y = dw_orig_y;
                        this.onSuccess();
                    } 

                } else {
                    this.panel.dw.visible = false;
                    this.panel.dw.x = dw_orig_x;
                    this.panel.dw.y = dw_orig_y;
                    this.onFail(this.panel.grid[coords.x][coords.y]);
                }
           }
            

        }
    };

    /**
     * Handler when Down Arrow Hover
     * @method  onArrowDownHover
     * @private
     */
    p.onArrowDownHover = function(event)
    {

        type = event.type;

        y = this.panel.dw.y;

        if (type == 'mouseover' && y < 268.5){
            this.panel.arrowDownBG.alpha = 1;
            this.panel.arrowDown.alpha = 1;
            app.sound.play('ButtonRollover');
        } else if (type == 'mouseout'){
            this.panel.arrowDownBG.alpha = 0;
            this.panel.arrowDown.alpha = 0;
        }
    };

    /**
     * Handler when the clicking on a grid item
     * @method  onArrowDownClick
     * @private
     */

     p.onArrowDownClick = function(event)
    {   
        if (disabled !== true){

            var x = this.panel.dw.x,
                y = this.panel.dw.y,
                dw_orig_x = 175,
                dw_orig_y = 68.5,
                target = event.target,
                coords, 
                valid = false;

            if (y < 268.5){
                this.panel.dw.y = y + 50;

                if (version != 'touch'){
                    this.panel.arrowDownBG.alpha = 0;
                    this.panel.arrowDown.alpha = 0;
                } else {
                    this.onTouchArrows();
                }

                app.sound.play('ButtonClick');
                coords = this.getGridPos();
                loc_vo = "loc_" + coords.x + "_" + coords.y;
                valid = true;
            }

            if (valid) {
                
                if (version == "ad"){
                    app.voPlayer.stop();
                    app.voPlayer.play(loc_vo);
                } 

                if (this.checkObstacle(coords.x, coords.y)){  
                    if (coords.x == 5 && coords.y == 5){              
                        this.panel.dw.x = dw_orig_x;
                        this.panel.dw.y = dw_orig_y;
                        this.onSuccess();
                    } 
                } else {
                    this.panel.dw.visible = false;
                    this.panel.dw.x = dw_orig_x;
                    this.panel.dw.y = dw_orig_y;
                    this.onFail(this.panel.grid[coords.x][coords.y]);
                }
            }
        }
    };

    /**
     * Handler when Left Arrow Hover
     * @method  onArrowLeftHover
     * @private
     */
    p.onArrowLeftHover = function(event)
    {
        type = event.type;

        x = this.panel.dw.x;

        if (type == 'mouseover' && x > 175){
            this.panel.arrowLeftBG.alpha = 1;
            this.panel.arrowLeft.alpha = 1;
            app.sound.play('ButtonRollover');
        } else if (type == 'mouseout'){
            this.panel.arrowLeftBG.alpha = 0;
            this.panel.arrowLeft.alpha = 0;
        }
    };

    /**
     * Handler when the clicking on a grid item
     * @method  onArrowLeftClick
     * @private
     */

     p.onArrowLeftClick = function(event)
    {   
        if (disabled !== true){

            var x = this.panel.dw.x,
                y = this.panel.dw.y,
                dw_orig_x = 175,
                dw_orig_y = 68.5,
                target = event.target,
                coords,
                valid = false;

            if (x > 175){
                this.panel.dw.x = x - 50;
                
                if (version != 'touch'){
                    this.panel.arrowLeftBG.alpha = 0;
                    this.panel.arrowLeft.alpha = 0;
                } else {
                    this.onTouchArrows();
                }

                app.sound.play('ButtonClick');
                coords = this.getGridPos();
                loc_vo = "loc_" + coords.x + "_" + coords.y;
                valid = true;
            }

               
            if (valid) {
                if (version == "ad"){
                    app.voPlayer.stop();
                    app.voPlayer.play(loc_vo);
                }

                if (this.checkObstacle(coords.x, coords.y)){  
                    if (coords.x == 5 && coords.y == 5){              
                        this.panel.dw.x = dw_orig_x;
                        this.panel.dw.y = dw_orig_y;
                        this.onSuccess();
                    } 
                } else {
                    this.panel.dw.visible = false;
                    this.panel.dw.x = dw_orig_x;
                    this.panel.dw.y = dw_orig_y;
                    this.onFail(this.panel.grid[coords.x][coords.y]);
                }
            }

        }
    };



    /**
     * Handler when Right Arrow Hover
     * @method  onArrowDownHover
     * @private
     */
    p.onArrowRightHover = function(event)
    {
        type = event.type;
        x = this.panel.dw.x;

        if (type == 'mouseover' && x < 375){
            this.panel.arrowRightBG.alpha = 1;
            this.panel.arrowRight.alpha = 1;
            app.sound.play('ButtonRollover');
        } else if (type == 'mouseout'){
            this.panel.arrowRightBG.alpha = 0;
            this.panel.arrowRight.alpha = 0;
        }       

    };

    /**
     * Handler when the clicking on a grid item
     * @method  onGridClick
     * @private
     */

     p.onArrowRightClick = function(event)
    {   
        if (disabled !== true){

            var x = this.panel.dw.x,
                y = this.panel.dw.y,
                dw_orig_x = 175,
                dw_orig_y = 68.5,
                target = event.target,
                coords,
                valid = false;


            if ( x < 375){
                this.panel.dw.x = x + 50;
                
                if (version != 'touch'){
                    this.panel.arrowRightBG.alpha = 0;
                    this.panel.arrowRight.alpha = 0;
                } else {
                    this.onTouchArrows();
                }

                app.sound.play('ButtonClick');
                coords = this.getGridPos();
                loc_vo = "loc_" + coords.x + "_" + coords.y;
                valid = true;
            }

               
            if (valid) {

                if (version == "ad"){
                    app.voPlayer.stop();
                    app.voPlayer.play(loc_vo);
                }

                if (this.checkObstacle(coords.x, coords.y)){  
                    if (coords.x == 5 && coords.y == 5){              
                        this.panel.dw.x = dw_orig_x;
                        this.panel.dw.y = dw_orig_y;
                        this.onSuccess();
                    } 
                } else {
                    this.panel.dw.visible = false;
                    this.panel.dw.x = dw_orig_x;
                    this.panel.dw.y = dw_orig_y;
                    this.onFail(this.panel.grid[coords.x][coords.y]);
                }
            }
        }
    };

    /**
     * Handler when Home is clicked
     * @method onHomeClick
     * @private
     */

     p.onHomeClick = function() {
        app.sound.stopAll();
        app.voPlayer.stop();

        if (version =='ad'){
            app.voPlayer.play(['home_1', 'home_2']);
        } else {
            app.voPlayer.play(['home_1', 'home2_alt_NAD']);
        }        

        this.panel.help_lives = 9;
        for (a = 0; a <= this.panel.help_lives; a++) {
            this.panel.help_life[a].visible = true;
        }

        var dw = this.panel.help_dw;
        var obstacle = this.panel.help_obstacleB;
        var bedout = this.panel.help_bedOut;
        var bedhappy = this.panel.help_bedhappy;
        var bedsad = this.panel.help_bedsad;
        var logo = this.panel.help_logo;
        var bk = this.panel.help_bkHeadCry;
        var bkBG = this.panel.help_kateBG;
        var welcome = this.panel.help_welcome;
        var sink = this.panel.help_sink;
        var intro = this.panel.help_introText;
        var overlay = this.panel.help_overlayBG;
        var play = this.panel.help_playBtn;
        var next = this.panel.help_nextBtn;
        var text = this.panel.help_stepText;
        helpStep = 1;

        this.panel.HelpContainer.visible = true;
        overlay.x = 173.5;
        overlay.y = 67;
        overlay.scaleX = 5;
        overlay.scaleY = 5;
        next.x = 365;
        next.y = 260;
        play.visible = true;
        play.x = 275;
        play.y = 260;        
        dw.visible = false;
        dw.x = 175;
        dw.y = 68.5;
        text.visible = false;
        sink.visible = false;
        bedsad.visible = false;
        bedout.visible = false;
        logo.visible = true;
        welcome.visible = true;
        bk.visible = true;
        bkBG.visible = true;
        intro.visible = true;
        bedhappy.visible = true;
        burst.visible = false;        
        obstacle.visible = false;
        this.onReset();
     };

    /**
     * Handler when Arrow/Enter Keys Pressed
     * @method  onKeyPress
     * @private
     */

     p.onKeyPress = function(event)
    {   
        event.preventDefault();
        
            var key_lt = 37, 
                key_rt = 39,
                key_up = 38, 
                key_dn = 40,
                key_h = 72,
                key_a = 65,
                key_enter = 13,
                dw_orig_x = 175,
                dw_orig_y = 68.5,
                x = this.panel.dw.x,
                y = this.panel.dw.y,
                valid = false,
                row_num,
                col_num;

            if (this.UIContainer.visible !== true) {
                coords = this.getGridPos();
                row_num = coords.x;
                col_num = coords.y;
            }

            // Set Bounds
            switch(event.keyCode) {

                case key_lt:
                    if (x !== 175 && this.UIContainer.visible !== true){
                        valid = true;
                        this.panel.dw.x = (x - 50);
                        col_num = col_num - 1;
                        app.sound.play("ButtonClick");
                    } else if (x == 175 && this.UIContainer.visible !== true) {
                        app.voPlayer.play('wall_bump');
                    }
                    break;
                case key_rt:
                    if (this.panel.HelpContainer.visible){
                        this.onNextClick();
                        app.sound.play("ButtonClick");
                    } else {
                        if (x !== 375 && this.UIContainer.visible !== true){
                            valid = true;
                            this.panel.dw.x = (x + 50);
                            col_num = col_num + 1;
                            app.sound.play("ButtonClick");
                        } else if (x == 375 && this.UIContainer.visible !== true) {
                            app.voPlayer.play('wall_bump');
                        }
                    }
                    
                    break;
                case key_up: 
                    if (this.panel.HelpContainer.visible){
                        app.voPlayer.stop();

                        switch(helpStep){
                            case 1:
                                if (version == 'ad'){
                                    app.voPlayer.play('home_2');
                                }
                                break;
                            case 2: 
                                if (version == 'ad'){
                                    app.voPlayer.play(['instruct1a', 'instruct1b', 'instruct1c', 'instruct1d','instruct_hear_again_alt']);
                                } else {
                                    app.voPlayer.play('instruct1a_NAD');
                                }     
                                break;
                            case 3:
                                if (version == 'ad'){
                                    app.voPlayer.play(['instruct2a', 'instruct2b', 'instruct_hear_again_alt']);
                                } else {
                                    app.voPlayer.play('instruct2a_NAD');
                                }     
                                break;
                            case 4: 
                                if (version == 'ad'){
                                    app.voPlayer.play(['instruct3a', 'instruct3b', 'instruct3c', 'instruct3d', 'instruct_hear_again_alt']);
                                } else {
                                    app.voPlayer.play('instruct3b_NAD');
                                }     
                                break;
                            case 5: 
                                if (version == 'ad'){
                                    app.voPlayer.play(['instruct4a', 'instruct4b', 'instruct_hear_again_alt']);
                                } else {
                                    app.voPlayer.play('instruct4a_NAD');
                                }     
                                break;
                            case 6: 
                                if (version == 'ad'){
                                    app.voPlayer.play(['instruct5a', 'instruct5b','instruct_hear_again_alt']);
                                } else {
                                    app.voPlayer.play('instruct5a_NAD');
                                }     
                                break;
                            case 7: 
                                if (version == 'ad'){
                                    app.voPlayer.play(['instruct6a', 'instruct6b', 'instruct_hear_again_alt']);
                                } else {
                                    app.voPlayer.play('instruct6a_NAD');
                                }                    
                                break;
                            case 8: 
                                if (version == 'ad'){
                                    app.voPlayer.play(['instruct7a_new', 'instruct_hear_again_alt']);
                                }  else {
                                    app.voPlayer.play('instruct7a_NAD_new');
                                }                   

                                break;
                            case 9: 
                                break;         
                        }
                    } else { 
                        if (y !== 68.5 && this.UIContainer.visible !== true){
                            valid = true;
                            this.panel.dw.y = (y - 50);
                            row_num = row_num - 1;
                            loc_vo = "loc_" + row_num + "_" + col_num;
                            app.sound.play("ButtonClick");
                        } else if (y == 68.5 && this.UIContainer.visible !== true){
                            app.voPlayer.play('wall_bump');
                        }
                    }                 
                    break;
                case key_dn:
                    if (y !== 268.5 && this.UIContainer.visible !== true){
                        valid = true;
                        this.panel.dw.y = (y + 50);
                        row_num = row_num + 1;
                        app.sound.play("ButtonClick");                     
                    } else if (y == 268.5 && this.UIContainer.visible !== true){
                        app.voPlayer.play('wall_bump');
                    }
                    break;

                case key_h:
                    if (this.panel.HelpContainer.visible){
                        this.voPlayer.stop();
                        this.onHelpReset();
                    } else {
                        this.voPlayer.stop();
                        this.onHelpClick();
                    }
                    break;

                case key_a:
                    if (version != 'touch'){
                        this.onADClick();
                    }                    
                    break;

                case key_enter:
                    valid = false;                    

                    if (this.panel.HelpContainer.visible){
                        app.voPlayer.stop();
                        app.sound.stopAll();
                        this.onPlayClick();
                    } else {
                        if (this.panel.tryAgain.visible && this.panel.UIContainer.visible){
                            app.voPlayer.stop();
                            app.sound.stopAll();
                            this.onTryAgain();
                        } else if (this.panel.playAgain.visible && this.panel.UIContainer.visible){
                            app.voPlayer.stop();
                            app.sound.stopAll();
                            this.onReset();
                        }                        
                    }
                    break;
            }

            if (valid) {                

                if (this.checkObstacle(row_num, col_num)){

                    if (version == 'ad') {
                        app.voPlayer.stop();
                        loc_vo = "loc_" + row_num + "_" + col_num;
                        app.voPlayer.play(loc_vo);
                    }
                    
                    if (this.panel.dw.x == 375 && this.panel.dw.y == 268.5){             
                        this.panel.dw.x = dw_orig_x;
                        this.panel.dw.y = dw_orig_y;
                        this.onSuccess();
                    } 

                } else {
                    obstacle = this.panel.grid[row_num][col_num];
                    this.panel.dw.visible = false;
                    this.panel.dw.x = dw_orig_x;
                    this.panel.dw.y = dw_orig_y;
                    this.onFail(obstacle);
                }

            } 
        };


    /**
     * Handler when sink is reached
     * @method  onSuccess
     * @private
     */
    p.onSuccess = function()
    {
        this.panel.glasses[this.panel.score_num].scaleX = 0.8;
        this.panel.glasses[this.panel.score_num].scaleY = 0.8;
        Tween.get(this.panel.glasses[this.panel.score_num], {override: true}).to({visible: true}).to({scaleX: 1.5, scaleY: 1.5}, 150).to({scaleX: 1, scaleY: 1}, 150);
        this.panel.glasses[this.panel.score_num].visible = true;
        this.panel.score_num++;
        this.panel.score_tally.text = this.panel.score_num;
        var success_vo = "success_" + this.panel.score_num;
        var tries = "tries_" + (this.panel.lives + 1);
       

        if (this.panel.score_num == 9){
            app.voPlayer.stop();

            if (version == 'ad') {
                app.voPlayer.play(["win", "winner", 250, "win_after_play_again"]);
            } else {
                app.voPlayer.play(["win"]);
            }

            // Hide Game Pieces
            this.panel.dw.visible = false;
            this.panel.sink.visible = false;

            // Hide UI stuff
            this.panel.obstacleText.visible = false;
            this.panel.tryAgain.visible = false;
            this.panel.gameOverText.visible = false;
            this.panel.gameOverText2.visible = false;

            // Show UI Stuff
            this.panel.winText.visible = true;
            this.panel.playAgain.visible = true;
            this.panel.playAgain.x = 38.5;
            this.panel.playAgain.y = 38.5;
            this.panel.dwWater.visible = true;

            // Set and Scale UI from Sink
            this.UIContainer.scaleX = 1;
            this.UIContainer.scaleY = 1;
            this.UIContainer.x = 373.5;
            this.UIContainer.y = 267;
            Tween.get(this.UIContainer, {override: true}).to({visible: true}).to({x: 173.5, y: 67, scaleX: 5, scaleY: 5}, 500);
            disabled = true;

        } else {
            app.sound.play('water');
            app.voPlayer.stop();
            if (version == 'ad'){
                app.voPlayer.play(['success_open',success_vo, tries, 500, 'loc_1_1']);
            }
            this.placeObstacles();
        } 

        if (version == 'touch') {
            this.onTouchArrows();
        } 
    };


    /**
     * Handler when the fail state is hit
     * @method  onFail
     * @private
     */
    p.onFail = function(target)
    {   
        var gameOver = false;
        var score;
        this.name = target.name;
        this.row_num = parseInt(this.name.substr(5,1));
        this.col_num = parseInt(this.name.substr(7,1));

        // Obstacle Set Up From Target
        obstacle = "this.panel." + this.panel.obstacles[this.row_num][this.col_num].obstacle;
        loc_vo = "loc_" + this.row_num + "_" + this.col_num;
        obstacle_text = this.panel.obstacles[this.row_num][this.col_num].obstacle + "_text";
        obstacle_sound = this.panel.obstacles[this.row_num][this.col_num].obstacle + "_sound";
        obstacle_vo = this.panel.obstacles[this.row_num][this.col_num].obstacle + "_vo";
        obstacle_vo_nad = obstacle_vo + "_nad";
        obstacle = eval(obstacle); // jshint ignore:line
        obstacle_text = eval(obstacle_text); // jshint ignore:line
        obstacle_sound = eval(obstacle_sound); // jshint ignore:line
        obstacle_vo = eval(obstacle_vo); // jshint ignore:line
        obstacle_vo_nad = eval(obstacle_vo_nad); // jshint ignore:line
        this.panel.obstacleText.text = "Whoops! D.W. stepped on a " + obstacle_text + ". Careful not to wake up Kate.";
        app.sound.play(obstacle_sound);
    
        // Reposition DW to Start
        this.panel.dw.x = 175;
        this.panel.dw.y = 68.5;

        // Hide Top and Left Arrows
        if (version == 'touch') {
            this.onTouchArrows();
        } 

        // Subract a Life
        lives = this.panel.lives;
        this.panel.life[lives].visible = false;
        this.panel.lives = lives - 1;

        if (this.panel.lives < 0){
            gameOver = true;
        }

        // Set DW Bed state
        this.panel.bedOut.visible = false;
        this.panel.bedhappy.visible = false;
        this.panel.bedsad.visible = true;

        // Hide UI Stuff  
        this.panel.winText.visible = false;
        this.panel.tryAgain.visible = false;
        this.panel.playAgain.visible = false;

        if (gameOver !== true){
            obstacle.visible = true;
            this.panel.tryAgain.visible = true;
            this.panel.playAgain.visible = false;
            this.panel.obstacleText.visible = true;
            this.panel.gameOverText.visible = false;
            this.panel.gameOverText2.visible = false;
            this.panel.bkCry.visible = false;

            if(version == 'ad'){
                var tries = "tries_" + lives;
                if (this.panel.score_num > 0){
                    score = "success_" + this.panel.score_num;
                    app.voPlayer.play([obstacle_vo, loc_vo, score, tries, "oops_after_try_again" ]);
                } else {
                    app.voPlayer.play([obstacle_vo, loc_vo, tries, "oops_after_try_again" ]);
                }
            } else {
                app.voPlayer.play([obstacle_vo_nad]);
            }

        } else {
            obstacle.visible = false;
            this.panel.tryAgain.visible = false;
            this.panel.playAgain.visible = true;
            this.panel.gameOverText.visible = true;
            // this.panel.gameOverText2.visible = true;
            this.panel.obstacleText.visible = false;
            this.panel.bkCry.visible = true;
            app.sound.play('cry', {loop: 2});

            if(version == 'ad'){
                if (this.panel.score_num > 0){
                    score = "success_" + this.panel.score_num;
                    app.voPlayer.play(['fail', score, 'oops_after_try_again']);
                } else {
                    app.voPlayer.play(['fail', 'oops_after_try_again']);
                }
            } else {
                app.voPlayer.play(['fail']);
            }
        }

        this.UIContainer.scaleX = 1;
        this.UIContainer.scaleY = 1;
        this.UIContainer.x = target.x;
        this.UIContainer.y = target.y;
        this.UIContainer.visible = true;
        this.panel.burst.visible = true;

        obText = this.panel.obstacleText;
        UI = this.UIContainer;

        Tween.get(this.panel.burst, {override: true}).to({visible: true}).wait(150).to({alpha: 0}).wait(150).to({alpha: 1}).wait(100).to({alpha: 0}).to({alpha: 1, visible: false}).call(sizeUI);

        function sizeUI(){
            Tween.get(UI, {override: true}).to({x: 173.5, y: 67, scaleX: 5, scaleY: 5}, 500);
        }        
        
        disabled = true;
        
    };

    /**
     * Handler when playAgain is clicked
     * @method  onReset
     * @private
     */
    p.onReset = function()
    {
        app.voPlayer.stop();
        app.sound.stopAll();

        // Reset Lives
        this.panel.lives = 9;
        for (a = 0; a <= this.panel.lives; a++) {
            this.panel.life[a].visible = true;
        }

        // Reset Score
        this.panel.score_num = 0;
        this.panel.score_tally.text = this.panel.score_num;
        for (a = 0; a<=8; a++){
            this.panel.glasses[a].visible = false;
        }

        // Hide UI Container
        this.panel.UIContainer.visible = false;
        this.panel.dw.visible = true;
        this.panel.sink.visible = true;
        
        this.panel.bedOut.visible = true;
        this.panel.bedhappy.visible = false;
        this.panel.bedsad.visible = false;
        this.panel.playAgain.visible = false;
        this.panel.tryAgain.visible = false;
        this.panel.dwWater.visible = false;
        this.newGame();
        this.placeObstacles();

        if (version == 'ad'){
            app.voPlayer.play(['game_intro_1','game_intro_2','game_intro_3', 'game_intro_5']);
        }
        
    };

    /**
     * Handler when playAgain is clicked
     * @method  onReset
     * @private
     */
    p.onTryAgain = function()
    {   
        app.voPlayer.stop();

        // Hide UI Container
        this.panel.UIContainer.visible = false;
        
        // Show Game Pieces
        this.panel.dw.visible = true;
        this.panel.sink.visible = true;
        
        // Appropriate DW
        this.panel.bedOut.visible = true;
        this.panel.bedhappy.visible = false;
        this.panel.bedsad.visible = false;        

        // Hide Obstacles / Text
        this.panel.obstacle1.visible = false;
        this.panel.obstacle2.visible = false; 
        this.panel.obstacle3.visible = false; 
        this.panel.obstacle4.visible = false;
        this.panel.obstacle5.visible = false; 
        this.panel.obstacle6.visible = false; 
        this.panel.obstacle7.visible = false; 
        this.panel.obstacle8.visible = false; 
        this.panel.obstacle9.visible = false; 
        this.panel.obstacleA.visible = false; 
        this.panel.obstacleB.visible = false; 
        this.panel.obstacleC.visible = false;
        
        if (version == 'ad'){
            app.voPlayer.play('loc_1_1');
        }       

        if (version == 'touch') {
            this.onTouchArrows();
        }

        disabled = false;
        
    };

    /**
     * Handler to find space on grid
     * @method  getGridPos
     * @private
     */

     p.getGridPos = function()
    {   
        if (disabled !== true){

            var x = this.panel.dw.x,
                y = this.panel.dw.y,
                coords = {x: 0, y: 0 };

            // Determine Where we are on Grid
            if (x == 175){
                coords.y = 1;
            } else if (x == 225){
                coords.y = 2;
            } else if (x == 275){
                coords.y = 3;
            } else if (x == 325){
                coords.y = 4;
            } else {
                coords.y = 5;
            }

            if (y == 68.5){
                coords.x = 1;
            } else if (y == 118.5){
                coords.x = 2;
            } else if (y == 168.5){
                coords.x = 3;
            } else if (y == 218.5){
                coords.x = 4;
            } else {
                coords.x = 5;
            }

            return coords;
        }
    };

    p.onHelpClick = function () {
        app.voPlayer.stop();
        this.onHelpReset();
        this.panel.HelpContainer.visible = true;
    };

     p.onHelpReset = function ()
    {
        app.sound.stopAll();
        app.voPlayer.stop();
        Tween.removeAllTweens();
        helpStep = 2;

        this.panel.help_overlayBG.x = 273.5;
        this.panel.help_overlayBG.y = 67;
        this.panel.help_overlayBG.scaleX = 3;
        this.panel.help_overlayBG.scaleY=  3;
        this.panel.help_playBtn.visible = false;
        this.panel.help_playBtn.x = 259;
        this.panel.help_playBtn.y = 263;
        this.panel.help_nextBtn.visible = true;
        this.panel.help_nextBtn.x = 365;
        this.panel.help_nextBtn.y = 158;
        this.panel.help_arrowUp.alpha = 0;
        this.panel.help_arrowUpBG.alpha = 0;
        this.panel.help_arrowRight.alpha = 0;
        this.panel.help_arrowRightBG.alpha = 0;
        this.panel.help_arrowLeft.alpha = 0;
        this.panel.help_arrowLeftBG.alpha = 0;
        this.panel.help_arrowDown.alpha = 0;
        this.panel.help_arrowDownBG.alpha = 0;        
        this.panel.help_stepText.text  = "D.W. is thirsty. Help her cross the dark room to get a glass of water.";
        this.panel.help_dw.visible = true;
        this.panel.help_dw.x = 175;
        this.panel.help_dw.y = 68.5;
        this.panel.help_sink.visible = true;
        this.panel.help_bedsad.visible = false;
        this.panel.help_bedOut.visible = true;
        this.panel.help_logo.visible = false;
        this.panel.help_welcome.visible = false;
        this.panel.help_bkHeadCry.visible = false;
        this.panel.help_kateBG.visible = false;
        this.panel.help_introText.visible = false;
        this.panel.help_bedhappy.visible = false;
        this.panel.help_burst.visible = false;
        this.panel.help_obstacleB.visible = false;
        this.panel.help_stepText.visible = true;

        if (version == "ad") {
            app.voPlayer.stop();
           app.voPlayer.play(['instruct1a', 'instruct1b', 'instruct1c', 'instruct1d','instruct_hear_again_alt']);
        } else {
            app.voPlayer.play(['instruct1a_NAD']);
        }

        // Reset Lives
        for (a = 0; a <= 9; a++) {
            this.panel.help_life[a].alpha = 1;
        }

        // Reset Score
        this.panel.help_score_tally.text = 0;
        for (a = 0; a<=8; a++){
            this.panel.help_glasses[a].visible = false;
        }        

    };

    p.onNextClick = function ()
    {
        app.voPlayer.stop();

        var text = this.panel.help_stepText;
        var dw = this.panel.help_dw;
        var x = this.panel.help_dw.x;
        var y = this.panel.help_dw.y;
        var up = this.panel.help_arrowUp;
        var upBG = this.panel.help_arrowUpBG;
        var right = this.panel.help_arrowRight;
        var rightBG = this.panel.help_arrowRightBG;
        var left = this.panel.help_arrowLeft;
        var leftBG = this.panel.help_arrowLeftBG;
        var down = this.panel.help_arrowDown;
        var downBG = this.panel.help_arrowDownBG;
        var glasses = this.panel.help_glasses;
        var score_tally = this.panel.help_score_tally;
        var burst = this.panel.help_burst;
        var obstacle = this.panel.help_obstacleB;
        var life = this.panel.help_life;
        var bedout = this.panel.help_bedOut;
        var bedhappy = this.panel.help_bedhappy;
        var bedsad = this.panel.help_bedsad;
        var logo = this.panel.help_logo;
        var bk = this.panel.help_bkHeadCry;
        var bkBG = this.panel.help_kateBG;
        var welcome = this.panel.help_welcome;
        var sink = this.panel.help_sink;
        var intro = this.panel.help_introText;

        if (helpStep < 9){
            helpStep++;
        }       

        function step2(){
            text.visible = true;
            bedout.visible = true;
            bedhappy.visible = false;
            bedsad.visible = false;
        }

        function step6(){
            dw.alpha = 1;
            dw.visible = 1;
            dw.x = 175;
            dw.y = 68.5;
            right.alpha = 1;
            rightBG.alpha = 1;
            down.alpha = 1;
            downBG.alpha = 1;
            text.text = 'But wait! Watch out for toys hiding in the dark! After each glass of water, more toys appear in the room.';
        }

        function step7(){
            app.sound.play('train');
            dw.visible = false;
            Tween.get(obstacle ,{override: true}).to({alpha: 1}).to({visible: true});
            Tween.get(burst, {override: true}).to({visible: true, alpha: 0}).wait(150).to({alpha: 1}, 200).to({alpha: 0}, 200).wait(150).to({alpha: 1}, 200).wait(150).to({alpha: 0}, 200).to({alpha: 1}, 200).call(removeLife);
            
            function removeLife(){
                life[9].alpha = 0;
                bedout.visible = false;
                bedhappy.visible = false;
                bedsad.visible = true;
            }

        }

        function step9() {
            // Show Hide
            dw.visible = false;
            dw.x = 175;
            dw.y = 68.5;
            sink.visible = false;
            bedsad.visible = false;
            bedout.visible = false;
            logo.visible = true;
            welcome.visible = true;
            bk.visible = true;
            bkBG.visible = true;
            intro.visible = true;
            bedhappy.visible = true;
            burst.visible = false;
            obstacle.visible = false;

            app.voPlayer.stop();

            // Reset Lives
            for (a = 0; a <= 9; a++) {
                life[a].alpha = 1;
            }

            // Reset Score
            score_tally.text = 0;
            for (a = 0; a<=8; a++){
                glasses[a].visible = false;
            }            
        }

        function showUp() {
            up.alpha = 1;
            upBG.alpha = 1;
        }

        function showLeft() {
            left.alpha = 1;
            leftBG.alpha = 1;
        }

        function hideDown() {
            down.alpha = 0;
            downBG.alpha = 0;
        }

        function hideAll(){
            up.alpha = 0;
            upBG.alpha = 0;
            down.alpha = 0;
            downBG.alpha = 0;
            right.alpha = 0;
            rightBG.alpha = 0;
            left.alpha = 0;
            leftBG.alpha = 0;
        }

        function score(){
            Tween.get(glasses[0], {override: true}).to({visible: true}).to({scaleX: 1.5, scaleY: 1.5}, 150).to({scaleX: 1, scaleY: 1}, 150);
            score_tally.text = 1;
            app.sound.play('water');
        }

        switch(helpStep){
            case 1:
                Tween.removeAllTweens();
                step9();
                intro.visible = true;
                intro.text = 'For directions, click the arrow. When you are ready to play, hit PLAY';

                if (version == 'ad'){
                    app.voPlayer.play('home_2');
                } else {
                    app.voPlayer.play('home_2_alt_NAD');

                }

                break;
            case 2: 
                Tween.removeAllTweens();
                logo.visible = false;
                welcome.visible = false;
                intro.visible = false;
                bkBG.visible = false;
                bk.visible = false;
                dw.visible = true;
                dw.alpha = 1;
                sink.visible = true;
                text.text = "D.W. is thirsty. Help her cross the dark room to get a glass of water.";
                this.panel.help_playBtn.visible = false;
                Tween.get(this.panel.help_nextBtn, {override: true}).to({ y: 158}, 250);
                Tween.get(this.panel.help_overlayBG, {override: true}).to({x: 273.5, y: 67, scaleX: 3, scaleY: 3}, 250).call(step2);

                if (version == 'ad'){
                    app.voPlayer.play(['instruct1a', 'instruct1b', 'instruct1c', 'instruct1d','instruct_hear_again_alt']);
                } else{
                    app.voPlayer.play(['instruct1a_NAD']);
                }                

                break;
            case 3:
                Tween.removeAllTweens();
                this.panel.help_playBtn.y = 163;
                this.panel.help_nextBtn.y = 158;
                this.panel.help_overlayBG.x = 273.5;
                this.panel.help_overlayBG.y = 67;
                this.panel.help_overlayBG.scaleX = 3;
                this.panel.help_overlayBG.scaleY = 3;                

                if (version == 'ad'){
                    app.voPlayer.play(['instruct2a', 'instruct2b', 'instruct_hear_again_alt']);
                    text.text = "Guide D.W. across the floor to the sink. Use the mouse or arrow keys.";
                } else if (version =='touch'){
                    app.voPlayer.play(['instruct2a_MOBILE']);
                    text.text = "Tap the arrows to guide D.W. across the floor to the sink.";
                    rightBG.alpha = 1;
                    right.alpha = 1;
                    downBG.alpha = 1;
                    down.alpha = 1;
                } else {
                    app.voPlayer.play(['instruct2a_NAD']);
                    text.text = "Guide D.W. across the floor to the sink. Use the mouse or arrow keys.";
                }
                break;

            case 4: 
                Tween.removeAllTweens();
                this.panel.help_dw.x = 175;
                this.panel.help_dw.y = 68.5;
                text.text = "Move ONE square at a time: right, left, up, or down.";
                rightBG.alpha = 1;
                right.alpha = 1;
                downBG.alpha = 1;
                down.alpha = 1;
                Tween.get(this.panel.help_dw, {override: true}).to({ y: y + 50}, 250).call(showUp).wait(200).to({ y: y + 100}, 250).wait(200).to({ y: y + 150}, 250).wait(250).to({ x: x + 50}, 250).call(showLeft).wait(200).to({ x: x + 100}, 250).wait(200).to({ x: x + 150}, 250).wait(200).to({ y: y + 200}, 250).call(hideDown).wait(200).to({ x: x + 200}, 250).call(hideAll);
                
                if (version == 'ad'){
                    app.voPlayer.play(['instruct3a', 'instruct3b', 'instruct3c', 'instruct3d', 'instruct_hear_again_alt']);
                } else {
                    app.voPlayer.play(['instruct3b_NAD']);
                }

                break;

            case 5: 
                Tween.removeAllTweens();
                text.text = "When she reaches the sink, D.W. gets 1 glass of water.";
                this.panel.help_dw.x = 375;
                this.panel.help_dw.y = 268.5;
                hideAll();
                score();
                Tween.get(this.panel.help_dw, {override: true}).to({alpha: 0}).wait(150).to({alpha: 1}).wait(150).to({alpha: 0}).wait(150).to({alpha: 1}).wait(150).to({alpha: 0});

                if (version == 'ad'){
                    app.voPlayer.play(['instruct4a', 'instruct4b', 'instruct_hear_again_alt']);
                } else {
                    app.voPlayer.play(['instruct4a_NAD']);
                }
                break;
            case 6: 
                Tween.removeAllTweens();
                Tween.get(this.panel.help_nextBtn, {override: true}).to({y: 208}, 250);
                Tween.get(this.panel.help_overlayBG, {override: true}).to({x: 273.5, y: 67, scaleX: 3, scaleY: 4}, 250).call(step6);
                if (version == 'ad'){
                    app.voPlayer.play(['instruct5a', 'instruct5b','instruct_hear_again_alt']);
                } else {
                    app.voPlayer.play(['instruct5a_NAD']);
                }

                break;
            case 7: 
                Tween.removeAllTweens();
                this.panel.help_playBtn.y = 208;
                this.panel.help_nextBtn.y = 208;
                this.panel.help_overlayBG.x = 273.5;
                this.panel.help_overlayBG.y = 67;
                this.panel.help_overlayBG.scaleY = 4;
                text.text = "Stepping on a toy sends D.W. back to the beginning, and you lose one turn.";
                Tween.get(this.panel.help_dw, {override: true}).to({ y: y + 50}, 250).call(showUp).wait(200).to({ y: y + 100}, 250).wait(200).call(hideAll).call(step7);
                
                if (version == 'ad'){
                    app.voPlayer.play(['instruct6a', 'instruct6b', 'instruct_hear_again_alt']);
                } else {
                    app.voPlayer.play(['instruct6a_NAD']);
                }   

                break;
            case 8: 
                Tween.removeAllTweens();
                life[9].alpha = 0;
                app.sound.play("fuss");
                dw.visible = false;
                obstacle.visible = false;
                burst.visible = false;
                this.panel.help_nextBtn.visible = false;
                this.panel.help_playBtn.x = 365;
                this.panel.help_playBtn.visible = true;
                text.text = "If you lose all 10 turns, Baby Kate wakes up and starts crying. That means you'll need to try again.";

                if (version == 'ad'){
                    app.voPlayer.play(['instruct7a_new', 'instruct_hear_again_short_alt']);
                } else {
                    app.voPlayer.play(['instruct7a_NAD_new']);
                }                

                for (i = 8;i >= 0;i--){
                    Tween.get(life[i], {override: true}).to({visible: true, alpha: 1 }).to({alpha: 0});
                }

                break;
        
        }
    };

    p.onPlayClick = function ()
    {    
        app.voPlayer.stop();
        coords = this.getGridPos();

        if (version == 'ad'){        
            app.voPlayer.stop();

            if (coords !== undefined){
                if ( coords.x == 1 && coords.y == 1 ){                
                    app.voPlayer.play(['game_intro_1','game_intro_2','game_intro_3', 'game_intro_5']);
                } else {
                    loc_vo = "loc_" + coords.x + "_" + coords.y;
                    app.voPlayer.play(['loc_intro_after_help',loc_vo]);
                }
            }

            if (this.panel.UIContainer.visible) {
                if (this.panel.playAgain.visible){
                    app.voPlayer.play("win_after_play_again");
                }

                if (this.panel.tryAgain.visible){
                    app.voPlayer.play("oops_after_try_again");
                }
            }            
        }

        this.panel.HelpContainer.visible = false;
    };



    p.onADClick = function () {
        app.voPlayer.stop();

        if (version  == 'normal'){
            version = 'ad';
            app.voPlayer.play('audio_description_on');
            this.panel.audioButton_active.visible = true;
            this.panel.help_audioButton_active.visible = true;

            this.panel.audioButton.visible = false;
            this.panel.help_audioButton.visible = false;

            if (this.panel.HelpContainer.visible){
                if (helpStep == 1){
                    app.voPlayer.play(['audio_description_on','home_1', "home_2"]);
                } else {
                    app.voPlayer.play(['audio_description_on']);
                }
            }

        } else {
            version = "normal";
            if (helpStep == 1){
                app.voPlayer.play(['audio_description_off','home_1', "home2_alt_NAD"]);
            } else {
                app.voPlayer.play(['audio_description_off']);
            }
            this.panel.audioButton_active.visible = false;
            this.panel.help_audioButton_active.visible = false;

            this.panel.audioButton.visible = true;
            this.panel.help_audioButton.visible = true;
        }

        console.log(version);
    };

    /**
     * When the state starts to exit, before transition
     * @method  exitStart
     */
    p.exitStart = function()
    {
        // Buttons
        this.panel.tryAgain.removeEventListener('click', this.onTryAgain);
        this.panel.playAgain.removeEventListener('click', this.onReset);
        this.panel.helpButton.removeEventListener('click', this.onHelpClick);

        // Mouse Movement and Hovers
        this.panel.arrowUpBG.removeEventListener('mouseover', this.onArrowUpHover);
        this.panel.arrowUpBG.removeEventListener('mouseout', this.onArrowUpHover);
        this.panel.arrowUpBG.removeEventListener('click', this.onArrowUpClick);

        this.panel.arrowDownBG.removeEventListener('mouseover', this.onArrowDownHover);
        this.panel.arrowDownBG.removeEventListener('mouseout', this.onArrowDownHover);
        this.panel.arrowDownBG.removeEventListener('click', this.onArrowDownClick);

        this.panel.arrowLeftBG.removeEventListener('mouseover', this.onArrowLeftHover);
        this.panel.arrowLeftBG.removeEventListener('mouseout', this.onArrowLeftHover);
        this.panel.arrowLeftBG.removeEventListener('click', this.onArrowLeftClick);

        this.panel.arrowRightBG.removeEventListener('mouseover', this.onArrowRightHover);
        this.panel.arrowRightBG.removeEventListener('mouseout', this.onArrowRightHover);
        this.panel.arrowRightBG.removeEventListener('click', this.onArrowRightClick);

        // Keyboard Controls
        window.removeEventListener('keydown', this.onKeyPress);   
    };

    //Assign to namespace
    namespace('WGBH').GameState = GameState;
}());